import { render, staticRenderFns } from "./abb.vue?vue&type=template&id=6f05fdb3&"
import script from "./abb.vue?vue&type=script&lang=js&"
export * from "./abb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports